import Input from './Input'
import Textarea from './Textarea'
import Select from './Select'
import RadioButtons from './RadioButtons'
import CheckboxGroup from './CheckboxGroup'
import DatePicker from './DatePicker'
import PasswordInput from './PasswordInput'
import ToggleButton from './ToggleButton'
import OtpInputField from './OtpInputField'
import TagsInput from './TagsInput'
import MetaTagsInput from './MetaTagsInput'
import FaqsInput from './FaqsInput'
import FileInputBase64 from './FileInputBase64'
import MultiFileBase64 from './MultiFileBase64'
import AudioFileInput from './AudioFileInput'
import FormikFileInput from './FormikFileInput'
import MultiSelect from './MultiSelect'
import DateInput from './DateInput'


function FormControl (props) {
    const { control, ...rest } = props;
    
    switch (control) {
        case 'input':
            return <Input {...rest} />
        case 'date-input':
            return <DateInput {...rest} />
        case 'otp':
            return <OtpInputField {...rest} />
        case 'textarea':
            return <Textarea {...rest} />
        case 'select':
            return <Select {...rest} />
        case 'multi-select':
            return <MultiSelect {...rest} />
        case 'radio':
            return <RadioButtons {...rest} />
        case 'checkbox':
            return <CheckboxGroup {...rest} />
        case 'date':
            return <DatePicker {...rest} />
        case 'password':
            return <PasswordInput {...rest} />
        case 'file':
            return <FormikFileInput {...rest} />
        case 'file-base64':
            return <FileInputBase64 {...rest} />
        case 'multi-file-base64':
            return <MultiFileBase64 {...rest} />
        case 'toggle':
            return <ToggleButton {...rest} />
        case 'audio':
            return <AudioFileInput {...rest} />
        case 'tags':
            return <TagsInput {...rest} />
        case 'meta':
            return <MetaTagsInput {...rest} />
        case 'faq':
            return <FaqsInput {...rest} />
        default:
            return null
    }
}

export default FormControl;
